export interface IParsedTimestamp {
  year: string;
  month: string;
  day: string;
  hour: string;
  minute: string;
  second: string;
}

/**
 * Parses a session name or block prefix value into its date and time components.
 * Expected format: "Name / YYYY-MM-DD HH-mm-ss"
 */
export function parseSessionTimestamp(value: string | undefined): IParsedTimestamp | null {
  if (!value) return null;

  try {
    const parts = value.split('/');
    if (parts.length < 2) return null;

    const dateTimeStr = parts[parts.length - 1].trim(); // "YYYY-MM-DD HH-mm-ss"
    const [dateStr, timeStr] = dateTimeStr.split(' ');
    if (!dateStr || !timeStr) return null;

    const dateParts = dateStr.split('-');
    const timeParts = timeStr.split('-');

    if (dateParts.length < 3 || timeParts.length < 3) return null;

    return {
      year: dateParts[0],
      month: dateParts[1],
      day: dateParts[2],
      hour: timeParts[0],
      minute: timeParts[1],
      second: timeParts[2],
    };
  } catch (error) {
    console.error('Error parsing session timestamp:', error);
    return null;
  }
}
